var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", [
    _c("input", {
      attrs: { type: "number" },
      domProps: { value: _vm.value },
      on: {
        "!input": function ($event) {
          return _vm.emitInput.apply(null, arguments)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }